import { MhcTimeSeriesGranularityEnum } from "graphqlApi/types";

import { capitalizeFirstLetter } from "common/util/helpers/string";

export const readableGranularityName = (granularity?: MhcTimeSeriesGranularityEnum | null) => {
  if (!granularity) return undefined;
  return capitalizeFirstLetter(granularity.replaceAll("_", " "));
};
